import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
  PMSmallNumberProps,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getPluralOfProjectName,
  getProjectName,
} from "../../../utils/get-plural-of-project-name";
import { getOverviewCardCopy } from "../get-card-copy";

export function addProjectCountCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { itemName, itemNamePlural, getCardCopy } = getOverviewCardCopy(app);

  const numberOfProjectsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfProjectsComponent",
      labels: ["#ofProjects"],
      description: "",
      title: "",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfProjectsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfProjectsComponent",
      labels: ["#ofProjects"],
      description: getCardCopy(language, "numberOfProjects").description,
      title: getCardCopy(language, "numberOfProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfProjectsComponent.mapState(
    ({ overview, reportComponentValues, settings, language }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title:
          a?.title ??
          getLocalizedCardCopy(language, "numberOfProjects", {
            itemName,
            itemNamePlural,
            projectName: getProjectName(
              settings?.configuration?.projectName,
              language
            ),
            projectNamePlural: getPluralOfProjectName(
              settings?.configuration?.projectName,
              language
            ),
          }).title,
        number: a?.number ?? overview?._calculated?.numberOfProjects ?? 0,
        description: getLocalizedCardCopy(
          language || "en",
          "numberOfProjects",
          {
            itemName,
            itemNamePlural,
            projectName: getProjectName(
              settings?.configuration?.projectName,
              language || "en"
            ),
            projectNamePlural: getPluralOfProjectName(
              settings?.configuration?.projectName,
              language || "en"
            ),
          }
        ).description,
      };
    }
  );

  const numberOfCompletedProjectsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfCompletedProjectsComponent",
      labels: ["#ofProjects"],
      description: "",
      title: "",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfCompletedProjectsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfCompletedProjectsComponent",
      labels: ["#ofProjects"],
      description: getCardCopy(language, "numberOfCompletedProjects")
        .description,
      title: getCardCopy(language, "numberOfCompletedProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfCompletedProjectsComponent.mapState(
    ({ overview, reportComponentValues, settings, language }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title: getLocalizedCardCopy(language, "numberOfCompletedProjects", {
          itemName,
          itemNamePlural,
          projectName: getProjectName(
            settings?.configuration?.projectName,
            language
          ),
          projectNamePlural: getPluralOfProjectName(
            settings?.configuration?.projectName,
            language
          ),
        }).title,
        number:
          a?.number ?? overview?._calculated?.numberOfCompletedProjects ?? 0,
        description: getLocalizedCardCopy(
          language || "en",
          "numberOfCompletedProjects",
          {
            itemName,
            itemNamePlural,
            projectName: getProjectName(
              settings?.configuration?.projectName,
              language || "en"
            ),
            projectNamePlural: getPluralOfProjectName(
              settings?.configuration?.projectName,
              language || "en"
            ),
          }
        ).description,
      };
    }
  );
}
